<template>
    <div class="uk-padding uk-background-muted " style="margin-top: -40px;">
        <div class="uk-container uk-container-small">
            <h1 class="uk-heading-divider uk-text-center "><span>Be a Beacon. Discovery Your Destiny!</span></h1>
            <iframe width="100%" height="404" src="https://www.youtube.com/embed/2Kb-eIAX6n8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
    </div>
</template>

<script>
    export default {
        name: "plea"
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h1{
            font-size: 1.4em !important;
        }

    }
</style>
